import { createSlice } from '@reduxjs/toolkit';
import dayjs, { Dayjs } from 'dayjs';

import { ISchedulePublicState } from '../ISchedulePublicState';

const initialState: ISchedulePublicState = {
  isGroupSchedule: true,
  searchText: null,
  requestText: null,
  requestTeacherId: null,

  currentDate: dayjs(),
  startIntervalDate: dayjs(),
  endIntervalDate: dayjs().add(25, 'day'),
};

export const schedulePublicSlice = createSlice({
  name: 'schedulePublic',
  initialState: initialState,
  reducers: {
    setSchedulePublicIsGroupSchedule: (
      state: ISchedulePublicState,
      action: {
        payload: boolean;
      },
    ) => {
      state.isGroupSchedule = action.payload;
    },
    setSchedulePublicSearchText: (
      state: ISchedulePublicState,
      action: {
        payload: string;
      },
    ) => {
      state.searchText = action.payload;
    },
    setSchedulePublicRequestText: (
      state: ISchedulePublicState,
      action: {
        payload: string;
      },
    ) => {
      state.requestText = action.payload;
    },
    setSchedulePublicRequestTeacherId: (
      state: ISchedulePublicState,
      action: {
        payload: string;
      },
    ) => {
      state.requestTeacherId = action.payload;
    },
    setSchedulePublicStartIntervalDate: (
      state: ISchedulePublicState,
      action: {
        payload: Dayjs;
      },
    ) => {
      state.startIntervalDate = action.payload;
    },
    setSchedulePublicEndIntervalDate: (
      state: ISchedulePublicState,
      action: {
        payload: Dayjs;
      },
    ) => {
      state.endIntervalDate = action.payload;
    },
  },
});
export const {
  setSchedulePublicSearchText,
  setSchedulePublicRequestText,
  setSchedulePublicEndIntervalDate,
  setSchedulePublicStartIntervalDate,
  setSchedulePublicRequestTeacherId,
  setSchedulePublicIsGroupSchedule,
} = schedulePublicSlice.actions;
export const schedulePublicReducer = schedulePublicSlice.reducer;
